import { Component, h, Host, Prop, State } from "@stencil/core";
import { OAuth2Client, OAuthStatusTypes } from "@trumpf/ux.utils";

/**
 * this component checks if the user has a valid session
 * and redirects to the login page if not
 */
@Component({
    tag: "ux-u-auto-auth",
    shadow: false
})
export class AutoAuth {
    /** Issuer URL of the OAuth2 provider */
    @Prop() readonly issuer: string;
    /** Client ID of the OAuth2 client */
    @Prop() readonly clientId: string;
    /** Client name of the OAuth2 client */
    @Prop() readonly clientName: string;
    /** Scope of the OAuth2 client */
    @Prop() readonly scope: string = "";
    /** Redirect URI of the OAuth2 client */
    @Prop() readonly redirectUri: string;
    /** Redirect URI passed to the SilentAuth component */
    @Prop() readonly silentAuthRedirectUri: string;

    private client: OAuth2Client;
    private unsubscribe: () => void;

    @State() status: OAuthStatusTypes;

    constructor() {
        // The OAuth2Client is initialized without clientName since it always uses the global client
        this.client = new OAuth2Client({
            issuer: `${this.issuer}/oauth2`,
            clientId: this.clientId,
            scope: this.scope,
            redirectUri: this.getOAuth2ClientRedirectUri()
        });
    }

    private getOAuth2ClientRedirectUri() {
        if (this.redirectUri) {
            return this.redirectUri;
        }
        return window.top ? window.top.location.href : window.location.href;
    }

    connectedCallback() {
        this.unsubscribe = this.client.subscribe(() => this.update);
    }

    disconnectedCallback() {
        this.unsubscribe();
    }

    private update = () => {
        this.status = this.client.getStatus();
    };

    private login() {
        this.client.login();
    }

    render() {
        return (
            <Host status={this.status}>
                <ux-u-silent-auth
                    issuer={this.issuer}
                    clientId={this.clientId}
                    clientName={this.clientName}
                    scope={this.scope}
                    redirectUri={this.silentAuthRedirectUri}
                    onUxAuth={(event) => {
                        if (event.detail.error) {
                            this.login();
                        }
                        this.update();
                    }}
                ></ux-u-silent-auth>
            </Host>
        );
    }
}
